/* MyGiftz — pijlknoppen voor horizontale rijen (okt 2026) */
(function () {
  function init(root) {
    root.querySelectorAll('[data-mg-scroller]').forEach(function (wrap) {
      if (wrap.__mgInit) return;
      wrap.__mgInit = true;
      var row = wrap.querySelector('[data-mg-row]');
      var prev = wrap.querySelector('[data-mg-prev]');
      var next = wrap.querySelector('[data-mg-next]');
      if (!row) return;
      var step = function () { return Math.max(row.clientWidth * 0.85, 200); };
      var update = function () {
        var max = row.scrollWidth - row.clientWidth - 2;
        if (prev) prev.disabled = row.scrollLeft <= 2;
        if (next) next.disabled = row.scrollLeft >= max;
      };
      if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Productpagina (okt 2026): op desktop blijft de linkerkolom (foto's + tabs eronder) in beeld staan
   terwijl je door een lange productbeschrijving/bundel aan de rechterkant scrolt, zodat er links geen
   lege ruimte ontstaat. Werkt samen met de CSS-regels '.mg-sticky-left' in mygiftz-base.css. */
(function () {
  if (window.__mgStickyLeft) return;
  window.__mgStickyLeft = true;
  var mq = window.matchMedia('(min-width: 1000px)');
  var observed = new WeakSet();

  function update() {
    var p = document.querySelector('.shopify-section--main-product .product');
    if (!p) return;
    var g = p.querySelector(':scope > product-gallery');
    var x = p.querySelector(':scope > #product-extra-information');
    if (!g) return;
    if (!mq.matches) { p.classList.remove('mg-sticky-left'); return; }
    [g, x].forEach(function (el) {
      if (el && !observed.has(el)) { observed.add(el); new ResizeObserver(schedule).observe(el); }
    });
    var gap = parseFloat(getComputedStyle(p).rowGap) || 0;
    var gh = g.offsetHeight;
    var xh = x ? x.offsetHeight : 0;
    var bar = document.querySelector('product-sticky-bar');
    var barH = bar ? bar.offsetHeight : 0;
    var total = gh + (xh ? gap + xh : 0);
    var top = Math.min(barH + 24, window.innerHeight - total - 24);
    p.style.setProperty('--mg-gh', (xh ? gh + gap : gh) + 'px');
    p.style.setProperty('--mg-xh', (xh ? xh + gap : 0) + 'px');
    p.style.setProperty('--mg-left-top', top + 'px');
    p.classList.add('mg-sticky-left');
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; update(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  if (mq.addEventListener) mq.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
